export const setImageCollection = (data) => ({
  type: 'SET_IMAGE_COLLECTION',
  imageCollection: data.imageCollection,
});

export const setFileNameExists = (data) => ({
  type: 'SET_FILE_NAME_EXISTS_STATE',
  isFileNameExists: data.isFileNameExists,
});

export const setMyinteractive = (data) => ({
  type: 'MY_INTERACTIVES',
  myInterActives: data,
});

export const setGlobalInteractive = (data) => ({
  type: 'GLOBAL_INTERACTIVES',
  globalInteractives: data,
});
export const setSharedInteractive = (data) => ({
  type: 'SHARED_INTERACTIVES',
  sharedInteractives: data,
});
